import compose from 'recompose/compose';
import formatPrismicData from '../../hocs/formatPrismicData';
import withMedia from 'src/client/js/view/hocs/withMediaQueries';
import OffersCarousel from './OffersCarousel';
import mapProps from 'recompose/mapProps';
import withCountry from '../../hocs/withCountry';

const enhance = compose(
  formatPrismicData,
  withCountry,
  withMedia,
  mapProps(props => ({
    ...props,
    items: props.items.map(item => item.offerDocument),
    fabletDown: props.media.fabletDown,
  }))
);

export default enhance(OffersCarousel);



// WEBPACK FOOTER //
// ./src/client/js/view/components/OffersCarousel/index.js